"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ExchangeRateSourceSpecEditor = class ExchangeRateSourceSpecEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    emitChange(...args) {
        let value = this.item;
        if (_.isEmpty(value.source) || _.isEmpty(value.rate_source)) {
            value = null;
        }
        this.$emit('input', value);
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    item;
    async $$load_item() {
        return this.value || {
            source: null,
            rate_source: null,
            invoice_description: null,
        };
    }
    sources;
    async $$load_sources() {
        return this.$app.repo.get('list_exchange_rate_source');
    }
    rateSources;
    async $$load_rateSources() {
        return this.$app.repo.get('ui_metadata', { path: 'exchange_rate_rate_source_type_options' });
    }
    ux;
    dataMembers = ['item', 'sources', 'rateSources', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                sources: null,
                rateSources: null,
                ux: null,
            },
        };
    }
    async act_5962862420439144_script_6660_getActionArgs_value($event) {
        this.emitChange();
    }
    async act_5962862420439144_script_6660_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_6660_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_input(event, scope) {
        return await this.actions.evh_5962862420439144_input.executeFromDOM(this, event, scope);
    }
    async act_8358196963355853_script_6662_getActionArgs_value($event) {
        this.emitChange();
    }
    async act_8358196963355853_script_6662_getActionArgs($event) {
        return {
            value: () => this.act_8358196963355853_script_6662_getActionArgs_value($event),
        };
    }
    async evh_8358196963355853_input(event, scope) {
        return await this.actions.evh_8358196963355853_input.executeFromDOM(this, event, scope);
    }
    async act_1048678296148443_script_6664_getActionArgs_value($event) {
        this.emitChange();
    }
    async act_1048678296148443_script_6664_getActionArgs($event) {
        return {
            value: () => this.act_1048678296148443_script_6664_getActionArgs_value($event),
        };
    }
    async evh_1048678296148443_input(event, scope) {
        return await this.actions.evh_1048678296148443_input.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_script_6660 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_6660_getActionArgs,
            displayName: "emitChange",
            events: [],
        });
        const evh_5962862420439144_input_6659 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_6660,
            event: "input",
            displayName: "emitChange",
        });
        const evh_5962862420439144_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_input_6659],
        });
        const act_8358196963355853_script_6662 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8358196963355853_script_6662_getActionArgs,
            displayName: "emitChange",
            events: [],
        });
        const evh_8358196963355853_input_6661 = new core_1.actions.EventHandlerImpl({
            action: act_8358196963355853_script_6662,
            event: "input",
            displayName: "emitChange",
        });
        const evh_8358196963355853_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8358196963355853_input_6661],
        });
        const act_1048678296148443_script_6664 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1048678296148443_script_6664_getActionArgs,
            displayName: "emitChange",
            events: [],
        });
        const evh_1048678296148443_input_6663 = new core_1.actions.EventHandlerImpl({
            action: act_1048678296148443_script_6664,
            event: "input",
            displayName: "emitChange",
        });
        const evh_1048678296148443_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1048678296148443_input_6663],
        });
        return {
            act_5962862420439144_script_6660,
            evh_5962862420439144_input_6659,
            evh_5962862420439144_input,
            act_8358196963355853_script_6662,
            evh_8358196963355853_input_6661,
            evh_8358196963355853_input,
            act_1048678296148443_script_6664,
            evh_1048678296148443_input_6663,
            evh_1048678296148443_input,
            emitChange: act_1048678296148443_script_6664,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], ExchangeRateSourceSpecEditor.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateSourceSpecEditor.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], ExchangeRateSourceSpecEditor.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateSourceSpecEditor.prototype, "onReadonly", null);
ExchangeRateSourceSpecEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], ExchangeRateSourceSpecEditor);
exports.default = ExchangeRateSourceSpecEditor;
vue_property_decorator_1.Vue.component("ExchangeRateSourceSpecEditor", ExchangeRateSourceSpecEditor);
